// extracted by mini-css-extract-plugin
export default {"root":"VerificationCode_root__gIWAJ","formWrapper":"VerificationCode_formWrapper__LxCUm","inputWrapper":"VerificationCode_inputWrapper__qsw94"};